import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Link as ScrollLink } from 'react-scroll';
import { FaBars, FaTimes } from 'react-icons/fa'; 
import styles from "./Navigation.module.css";
import LogoImage from '../../data/Images/logo.png'

const Navigation = () => {

  const [menuOpen, setMenuOpen] = useState(false); 
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  const location = useLocation();
  const navigate = useNavigate();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle active section detection
  useEffect(() => {
    if (location.pathname === '/') {
      const handleSectionChange = () => {
        const sections = ['home', 'about', 'packages', 'services', 'contact'];
        const scrollPosition = window.scrollY + 100;

        for (const section of sections) {
          const element = document.getElementById(`${section}-section`);
          if (element) {
            const { offsetTop, offsetHeight } = element;
            if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
              setActiveSection(section);
              break;
            }
          }
        }
      };

      window.addEventListener('scroll', handleSectionChange);
      handleSectionChange(); // Initial check
      return () => window.removeEventListener('scroll', handleSectionChange);
    }
  }, [location.pathname]);

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    setMenuOpen(!menuOpen);
  };

  // Close the menu when a link is clicked
  const closeMenu = () => {
    setMenuOpen(false);
  };

  const goBack = () => {
    navigate(-1);
  };

  const isHomePage = location.pathname === '/';

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen &&
          !event.target.closest(`.${styles.navigation}`) &&
          !event.target.closest(`.${styles.hamburgerMenu}`)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => document.removeEventListener('click', handleClickOutside);
  }, [menuOpen]);

  return (
    <nav className={`${styles.navigation} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.navigationContainer}>

        {isHomePage && (
        <div className={styles.hamburgerMenu} onClick={handleMenuToggle}>
          {menuOpen ? <FaTimes size={20} /> : <FaBars size={22} />}
        </div>
        )}

        {!isHomePage && (
        <button className={styles.backButtonNav} onClick={goBack}>
          ← Back
        </button>
        )}

        <Link to="/" onClick={closeMenu}>
          <div className={styles.navbarLogo}>
            <img src={LogoImage} alt='Flight Hub Reservation' className={styles.logoImage} />
          </div>
        </Link>


        <div className={`${styles.navbarCenter} ${menuOpen ? styles.active : ''}`} data-menu-open={menuOpen}>
          {/* Links section */}
          {isHomePage && (
          <div className={styles.navbarLinks}>
           <ScrollLink 
             to="home-section" 
             smooth={true} 
             duration={500} 
             onClick={closeMenu}
             className={`${styles.navLink} ${activeSection === 'home' ? styles.active : ''}`}
           >
              HOME
            </ScrollLink>
            <ScrollLink 
              to="about-section" 
              smooth={true} 
              duration={500} 
              onClick={closeMenu}
              className={`${styles.navLink} ${activeSection === 'about' ? styles.active : ''}`}
            >
              ABOUT
           </ScrollLink>
           <ScrollLink
             to="packages-section"
             smooth={true}
             duration={500}
             onClick={closeMenu}
             className={`${styles.navLink} ${activeSection === 'packages' ? styles.active : ''}`}
           >
             PACKAGES
            </ScrollLink>

            <ScrollLink
              to="services-section"
              smooth={true}
              duration={500}
              onClick={closeMenu}
              className={`${styles.navLink} ${activeSection === 'services' ? styles.active : ''}`}
            >
              SERVICES
           </ScrollLink>

            <ScrollLink 
              to="contact-section" 
              smooth={true} 
              duration={500} 
              onClick={closeMenu}
              className={`${styles.navLink} ${activeSection === 'contact' ? styles.active : ''}`}
            >
              CONTACT
           </ScrollLink>
          </div>
            )}
        </div>


      </div>
    </nav>
  );
};

export default Navigation;
